export default function BlogPost({ post, openPost, className = '' }) {
    return (
      <div className={`blog-post border border-slate-300 flex flex-col sm:flex-row p-vw-6 gap-vw-18 ${className}`}>
        <div className="post-thumbnail">{post.thumbnail && <img src={post.thumbnail} alt={post.title} />}</div>
        <div className="post-content flex flex-col gap-2">
          <h2 className="post-title sm:text-vw-3xl text-vw-5xl font-bold sm:mb-0 mb-vw-4">{post.title}</h2>
          <div className="sm:text-vw-3xl text-vw-4xl leading-min">{post.excerpt && <div className="post-excerpt" dangerouslySetInnerHTML={{ __html: post.excerpt }} />}</div>
          <a className="mt-auto text-primary sm:text-vw-xl text-vw-3xl hover:underline" href={post.htmlUrl} onClick={openPost}>Read more</a>
        </div>
      </div>
    );
  };